// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/newsletter/newsletter.scss
 ** module id = 74
 ** module chunks = 0 1
 **/